import React from 'react';
import { graphql } from 'gatsby';
import get from 'lodash/get';
import Layout from '../components/layout/layout';
import { Helmet } from 'react-helmet';
import Img from 'gatsby-image';

import './chi-siamo.scss';

class AboutPage extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title');

    const pageInfo = get(this, 'props.data.pageInfo');
    const heroImage = pageInfo.heroImage.fluid;

    return (
      <Layout location={this.props.location}>
        <Helmet title={siteTitle}>
          <meta name="description" content="Spazio 536 - Centro estetico" />
        </Helmet>
        <Img fluid={heroImage} className="full-width-img" />

        {pageInfo.sections.map(section => (
          <>
            {section.title && (
              <>
                <h4 className="page__title">{section.title}</h4>
                <hr />
                <span className="page__subtitle" style={{ marginBottom: '0' }}>
                  {section.subtitle}
                </span>
              </>
            )}

            {section.image && (
              <Img
                fluid={section.image.fluid}
                className={section.immagineALarghezzaPiena ? 'full-width-img' : ''}
                style={{ border: 'none', marginTop: '200px' }}
              />
            )}

            {section.description && (
              <span className="service__description">{section.description?.description}</span>
            )}
          </>
        ))}
      </Layout>
    );
  }
}

export default AboutPage;

export const pageQuery = graphql`
  query AboutQuery {
    site {
      siteMetadata {
        title
      }
    }
    pageInfo: contentfulPaginaWeb(webPageTitle: { eq: "Chi Siamo" }) {
      heroImage {
        fluid {
          ...GatsbyContentfulFluid_tracedSVG
        }
      }

      sections {
        title
        subtitle

        immagineALarghezzaPiena

        description {
          description
        }

        image {
          fluid {
            ...GatsbyContentfulFluid_tracedSVG
          }
        }
      }
    }
  }
`;
